import { useState as t } from "react";
const T = 0;
function i(r, h, u, o, a, e) {
  const [c, g] = t(!1), s = c ? u : o, [C, f] = t(s ? s.length : T), [O, n] = t(!1);
  return {
    valueCounter: C,
    isOnBlur: O,
    hasLabelOrHelperText: !!(r ?? h),
    handleBlur: () => {
      n(!0), e == null || e();
    },
    handleChange: (l) => {
      g(!0), f(l.target.value.length), a && a(l), n(!1);
    }
  };
}
export {
  i as useTextarea
};
